<template lang="pug">
  .page
    header.header-settings
      .tabs
        .tab.primary-text.active
          span Import Data

    .sub-section
      p Use our template csv file and format yours accordingly to get started quickly!
      a.link(href="https://assets-cdn.feature.watch/templates/import_template.csv", target="_blank") Download Template
    div
      form(@submit.prevent="submit")
        div.form-field
          form-upload(
            @uploaded="uploaded",
            @uploading="uploadState = 'uploading'"
            @errored="uploadState = 'errored'"
            size="full",
            endpoint="attachment"
            accept=".csv"
          )
            button.button.upload.icon-w-text(type="button", :class="{success: uploadState === 'success', 'error-button': $v.form.url.$error && !$v.form.url.required}")
              .row.center
                .col
                  font-awesome-icon.icon(:icon="['fad','file-csv']", fixed-width, v-if="['initial', 'errored'].indexOf(uploadState) > -1 ")
                  font-awesome-icon.icon(:icon="['fad','spinner-third']", fixed-width, spin, v-if="uploadState === 'uploading'")
                  font-awesome-icon.icon(:icon="['fas','check']", fixed-width, v-if="uploadState === 'success'")
                .col
                  div(v-if="!form.url")
                    h6 Upload CSV
                    span Make sure it is formatted properly
                  div(v-else)
                    h6 {{ attachment.fileName }}
                    span {{ attachment.fileSize }} bytes
        div.form-field
          SubmitButton(label="Upload", :formState="formState", @stateChange="stateChange")

</template>

<script>
// title, description, status

import { required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import { form } from '@/mixins/form'

import FormUpload from '@/components/form/FormUpload'

export default {
  name: 'BoardSettingsImport',
  components: {
    FormUpload
  },
  mixins: [form],
  data() {
    return {
      attachment: null,
      uploadState: 'initial',
      formState: 'initial',
      form: {
        url: null
      }
    }
  },
  validations: {
    form: {
      url: {
        required
      }
    }
  },
  computed: {
    ...mapGetters({})
  },
  methods: {
    uploaded(attachment) {
      this.$set(this.form, 'url', attachment.url)
      console.log(attachment)
      this.attachment = attachment
      this.uploadState = 'success'
    },

    submit() {
      //this.$toast.open('message string');
      if (this.__formInvalid()) return

      this.formState = 'pending'

      this.$store.dispatch('features/importFeatures', this.form).then(
        () => {
          this.formState = 'success'
          this.$v.$reset()
          this.uploadState = 'initial'
          this.form.url = null
          this.attachment = null
        },
        () => {
          this.formState = 'error'

          this.$v.$reset()
          this.uploadState = 'initial'
          this.form.url = null
          this.attachment = null
        }
      )
    },

    stateChange(state) {
      console.log('stateChange', state)
      this.formState = state
    }
  }
}
</script>

<style scoped lang="stylus">

button.button.icon-w-text.success
  border-color $color-primary-lighter
  .icon
    color $color-primary-lighter
button.button.icon-w-text.error-button
  border-color $color-alert
</style>
